import React from "react";
import "../../assets/css/components/skeletoloadig/WorkerSubscriptionHistorySkeleton.css";

const WorkerSubscriptionHistorySkeleton = () => {
    return (
        <div className="wsh-sk-page">

            {/* Mobile Header */}
            <div className="wsh-sk-mob-header d-md-none">
                <div className="wsh-sk-back-btn skeleton"></div>

                <div style={{ flex: 1 }}>
                    <div className="sk-line sk-title skeleton"></div>
                    <div className="sk-line sk-small skeleton"></div>
                </div>

                <div className="wsh-sk-refresh skeleton"></div>
            </div>


            <div className="wsh-sk-container">

                {/* Desktop Header */}
                <div className="wsh-sk-desk-header">

                    <div className="wsh-sk-back-btn skeleton"></div>

                    <div style={{ width: "100%" }}>
                        <div className="sk-line sk-title skeleton"></div>
                        <div className="sk-line sk-small skeleton"></div>
                    </div>

                    <div className="wsh-sk-refresh skeleton"></div>

                </div>


                {/* Current Subscription */}
                <div className="wsh-sk-current-card skeleton">

                    {/* Top */}
                    <div className="wsh-sk-current-card__top">

                        <div className="wsh-sk-current-card__left">

                            <div className="wsh-sk-current-card__icon skeleton"></div>

                            <div style={{ flex: 1 }}>

                                <div className="sk-line sk-medium skeleton"></div>

                                <div className="sk-line sk-small skeleton"></div>

                            </div>

                        </div>

                        <div className="sk-status skeleton"></div>

                    </div>


                    {/* Countdown */}
                    <div className="wsh-sk-countdown">

                        {[1, 2, 3, 4].map((i) => (
                            <div
                                key={i}
                                className="wsh-sk-countdown-unit skeleton"
                            >
                                <div className="sk-count"></div>
                                <div className="sk-mini"></div>
                            </div>
                        ))}

                    </div>


                    {/* Dates */}
                    <div className="wsh-sk-progress-wrap">

                        <div className="wsh-sk-date-block">
                            <div className="sk-mini skeleton"></div>
                            <div className="sk-date skeleton"></div>
                        </div>

                        <div className="wsh-sk-progress-bar skeleton">
                            <div className="wsh-sk-progress-fill"></div>
                        </div>

                        <div className="wsh-sk-date-block">
                            <div className="sk-mini skeleton"></div>
                            <div className="sk-date skeleton"></div>
                        </div>

                    </div>


                    {/* Features */}
                    <div className="wsh-sk-current-features">

                        {[1, 2, 3].map((i) => (
                            <div
                                key={i}
                                className="sk-feature skeleton"
                            ></div>
                        ))}

                    </div>


                    {/* Upgrade Button */}
                    <div className="wsh-sk-upgrade-btn skeleton"></div>

                </div>


                {/* History */}
                <div className="wsh-sk-history-section">

                    <div className="wsh-sk-history-header">

                        <div className="sk-line sk-title skeleton"></div>

                    </div>


                    {[1, 2, 3, 4].map((i) => (

                        <div
                            className="wsh-sk-history-item"
                            key={i}
                        >

                            <div className="wsh-sk-history-item__left">

                                <div className="wsh-sk-history-item__icon skeleton"></div>

                                <div style={{ flex: 1 }}>

                                    <div className="sk-line sk-medium skeleton"></div>

                                    <div className="sk-line sk-small skeleton"></div>

                                    <div className="sk-line sk-mini skeleton"></div>

                                </div>

                            </div>


                            <div className="wsh-sk-history-right">

                                <div className="sk-price-sm skeleton"></div>

                                <div className="sk-mini skeleton"></div>

                            </div>

                        </div>

                    ))}

                </div>


                {/* Footer */}
                <div className="sk-footer skeleton"></div>

            </div>

        </div>
    );
};

export default WorkerSubscriptionHistorySkeleton;